import { useLayoutEffect, useState } from 'react';
import { isMobileLayout } from '../../utilities/isMobileLayout/isMobileLayout';
import { getMediaQueryList } from '../../utilities/getMediaQueryList/getMediaQueryList';
import { Breakpoints } from '../../components/Experimenter/types';

export function useIsMobileLayout(screenMaxWidth = Breakpoints.MD) {
  const [isMobile, setIsMobile] = useState(() => isMobileLayout(screenMaxWidth));
  const mediaListQuery = getMediaQueryList(screenMaxWidth);
  useLayoutEffect(() => {
    mediaListQuery?.addEventListener('change', () => {
      setIsMobile(mediaListQuery.matches);
    });
  }, [mediaListQuery, setIsMobile]);

  return isMobile;
}
